import { QueryClient } from "@tanstack/react-query";
import { EntryCollection } from "contentful";
import { GetStaticPaths, GetStaticProps } from "next";
import getClient from "src/services/contentful/contentful";
import getFooterSection from "src/services/contentful/footer/getFooterMenu";
import { getHeaderMenuGraphQL } from "src/services/contentful/mainHeader/getMainHeader";
import { getSiteSettingsGql } from "src/services/contentful/settings/settings";
import getTeamMember from "src/services/contentful/teamMember/getTeamMember";
import { ITeamMemberFields } from "src/types/generated/contentful";

export { default } from "src/pages/teamMember";

export const getStaticProps: GetStaticProps = async ({
  params,
  preview = false,
}) => {
  const teamMember = await getTeamMember(params?.slug as string, true);

  const queryClient = new QueryClient();

  let headergql = await getHeaderMenuGraphQL({
    preview: preview || false,
    queryClient,
  });
  let settings = await getSiteSettingsGql({
    queryClient,
    preview: preview || false,
  });
  let footerMenu = await getFooterSection({
    query: {
      limit: 1,
      include: 5,
      select: "sys.id,sys.contentType,sys.type,fields",
    },
    preview: preview || false,
  });
  return {
    props: {
      settings,
      preview,
      teamMember,
      header: headergql,
      footerMenu,
      consentVisible: true,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async (data) => {
  //console.log("getStaticPaths:TeamMember", data);
  let paths: any[] = [];
  try {
    const entries = await getClient({ preview: false }).getEntries({
      content_type: "teamMember",
      //@ts-ignore
      select: "fields.slug",
    });

    paths = entries.items
      .filter(
        ({ fields }: any) =>
          fields && fields.slug && typeof fields.slug === "string"
      )
      .map(({ fields }: any) => `/team-member/${fields.slug}`);

    // console.log("team-member/[slug]", paths);
  } catch (err) {
    console.warn('No team-member pages found');
  }

  return {
    paths,
    fallback: true,
  };
};
